import React from "react";

interface IconProps {
  color: string;
  className: string;
}

const Icon: React.FC<IconProps> = ({ color, className }) => (
  <svg className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill={color}
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.0001 1.66669C5.40008 1.66669 1.66675 5.40002 1.66675 10C1.66675 14.6 5.40008 18.3334 10.0001 18.3334C14.6001 18.3334 18.3334 14.6 18.3334 10C18.3334 5.40002 14.6001 1.66669 10.0001 1.66669ZM10.0001 4.16669C11.3834 4.16669 12.5001 5.28335 12.5001 6.66669C12.5001 8.05002 11.3834 9.16669 10.0001 9.16669C8.61675 9.16669 7.50008 8.05002 7.50008 6.66669C7.50008 5.28335 8.61675 4.16669 10.0001 4.16669ZM10.0001 16C7.91675 16 6.07508 14.9334 5.00008 13.3167C5.02508 11.6584 8.33342 10.75 10.0001 10.75C11.6584 10.75 14.9751 11.6584 15.0001 13.3167C13.9251 14.9334 12.0834 16 10.0001 16Z"
    />
  </svg>
);

export const AccountCircle: React.FC<IconProps> = ({ color, className }) => {
  return <Icon className={className} color={color} />;
};
